export default "__VITE_ASSET__8314547f__"